const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  INTERACTIVE_MODULE: 'INTERACTIVE_MODULE',
};

export { MEDIA_TYPES };

export default MEDIA_TYPES;
